import React, { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import useTableGenerator from '../../common/functions/useTableGenerator';
import schema from './jsonSchemaDayClass';

const ClassTemplateTable = ({ days, deleteClassTemplate }) => {
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  const deleteClassTemplateDay = identification => {
    deleteClassTemplate(identification);
    /*TemplateService.deleteClassTemplate(identification)
      .then(response => {
        console.log(response);
      })
      .catch(error => console.log(error));*/
  };
  const jsonSchema = schema;
  const actionButtons = [
    {
      icon: 'trash-alt',
      onClick: identifier => {
        console.log('Identifier', identifier);
        deleteClassTemplateDay(identifier);
      },
      className: 'p-0',
      title: 'Delete',
      variant: 'action'
    }
  ];

  const tableGenerated = useTableGenerator(days, jsonSchema, actionButtons);
  useEffect(() => {
    setNoDataToShow(!days || days.length === 0);
  }, [days]);

  return (
    <>
      {error}
      {!days && (
        <Alert key="warning" variant="warning">
          There's not any days for this template to show.
        </Alert>
      )}
      {tableGenerated}
    </>
  );
};

export default ClassTemplateTable;
